kombi.disableCollapseFields = function () {
  let toggleFields = function (item, disable) {
    item.querySelectorAll("input, select, textarea, button").forEach((field) => {
      field.disabled = disable;
    });
  }
  document.querySelectorAll(".disable-collapse-fields").forEach((item) => {
    item.addEventListener('hidden.bs.collapse', event => {
      toggleFields(item, true)
    });
    item.addEventListener('show.bs.collapse', event => {
      toggleFields(item, false)
    });

    toggleFields(item, !item.classList.contains("show"))
  });
}
